<div class="cortes-container">
  <div class="header-actions">
    <h1>Cortes por Proveedor</h1>
  </div>

  <app-table-generic
    [config]="(tableConfig$ | async) || { columns: [] }"
    [data]="(data$ | async) || []"
    [totalItems]="(totalItems$ | async) || 0"
    [loading]="(loading$ | async) || false"
    [error]="error$ | async"
    [dialogComponent]="dialogComponent"
    [serverSide]="true"
    [pageIndexInput]="currentPage$.value"
    [pageSizeInput]="pageSize$.value"
    [canDelete]="false"
    [canEdit]="false"
    (editClick)="onEdit($event)"
    (deleteClick)="onDelete($event)"
    (detailsClick)="onViewDetails($event)"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)">
  </app-table-generic>
</div>

